module.exports = __webpack_public_path__ + "img/witch-doctor.db86c429.png";